import { useSelector } from 'react-redux';
import React, { useEffect, useMemo, useState } from 'react';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { waitFor } from './map';
import { FlowStyle } from './style';
import useInitLoading from '../../../../../helpers/useInitLoading';
import SupplyChainMap from '../../../../dashboards/components/SupplyChainMap';
import ComponentWithFocus from '../../../../../screens/Analysis/components/component-with-focus';

const Flow = ({
  scm = {},
  trade = null,
  supplyChainMapCallback = () => { },
  setReports = () => { },
  canFetch,
  datastakeId = null,
  projectData = {},
  openSettings = () => { },
}) => {
  const { user } = useSelector((state) => state.authentication);
  const defaultSources = useMemo(() => (scm.sources || []).map((s) => s.id), [scm]);
  const [loadingData, setLoadingData] = useState(true);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const userSettings = useMemo(() => {
    return (user?.settings?.projects || []).find((s) => s.id === projectData?.id)
  }, [user, projectData]);

  const disabledIds = useMemo(() => {
    return userSettings?.visualisation?.selectedScp || [];
  }, [userSettings]);

  const _fetch = async () => {
    setLoadingData(true);
    await waitFor(1000);
    setLoadingData(false);
  }

  useEffect(() => {
    if (canFetch) {
      _fetch();
    }
  }, [canFetch]);

  const loading = useMemo(() => {
    return !scm || !datastakeId || !trade;
  }, [scm, datastakeId, trade]);

  const { loaded } = useInitLoading({ hasData: !loadingData, timeout: 100 });

  const [closed, setClosed] = useState(false);
  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => { },
  }), [closed]);

  return (
    <FlowStyle>
      {loadingData || loading ? (
        <WidgetLoader background="white" />
      ) : (
        <ComponentWithFocus actions={actions} show={popoverVisible}>
          <div className="flow-body">
            <SupplyChainMap
              setPopoverVisible={setPopoverVisible}
              sources={scm.sources}
              empty={!userSettings?.visualisation?.focusScp?.value}
              defaultSources={defaultSources}
              trade={trade}
              datastakeId={datastakeId}
              callback={supplyChainMapCallback}
              height={628}
              title='Identified Trade Relationships'
              projectData={projectData}
              type="SC_PROJECT"
              openSettings={openSettings}
              loadingComponent={!loaded}
              setReports={setReports}
              disabledIds={disabledIds}
              defaultActive={userSettings?.visualisation?.focusScp?.value}
            />
          </div>
        </ComponentWithFocus>
      )}
    </FlowStyle>
  );
};

export default Flow;
